// EditBannerModal.jsx

import React, {
  useEffect,
  useState,
} from 'react';

import {
  useUpdateBanner,
} from '../hooks/useBanner';

const EditBannerModal = ({
  isOpen,
  onClose,
  banner,
}) => {

  const [campaignName, setCampaignName] =
    useState('');

  const [screenName, setScreenName] =
    useState('');

    const [hyperLink, setHyperLink] =
  useState('');

  const [image, setImage] =
    useState(null);

  const [preview, setPreview] =
    useState('');

  // UPDATE MUTATION
  const updateMutation =
    useUpdateBanner();

  // PREFILL
  useEffect(() => {

    if (banner) {

      setCampaignName(
        banner.campaign_name || ''
      );

      setScreenName(
        banner.screen_name || ''
      );

      setHyperLink(
  banner.hyper_link || ''
);

      setPreview(
        banner.banner_img_key || ''
      );
    }

  }, [banner]);

  // CLOSE
  if (!isOpen || !banner) return null;

  // IMAGE CHANGE
  const handleImageChange = (e) => {

    const file = e.target.files?.[0];

    if (!file) return;

    setImage(file);

    setPreview(
      URL.createObjectURL(file)
    );
  };

  // SUBMIT
  const handleSubmit = async (e) => {

    e.preventDefault();

    if (
  hyperLink &&
  !/^https?:\/\/.+/.test(
    hyperLink
  )
) {

  alert(
    'Please enter valid URL'
  );

  return;
}

    try {

      const formData =
        new FormData();

      formData.append(
        'campaign_name',
        campaignName
      );

      formData.append(
  'hyper_link',
  hyperLink
);

      formData.append(
        'screen_name',
        screenName
      );

      if (image) {
        formData.append(
          'file',
          image
        );
      }

      await updateMutation.mutateAsync({

        bannerId: banner._id,

        formData,
      });

      alert(
        'Banner updated successfully'
      );

      onClose();

    } catch (error) {

      console.error(error);

      alert(
        error?.response?.data?.message ||
        'Failed to update banner'
      );
    }
  };

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4'>

      <div className='bg-white rounded-xl w-full max-w-lg p-6 shadow-xl'>

        {/* HEADER */}
        <div className='flex items-center justify-between mb-6'>

          <h2 className='text-xl font-semibold text-gray-900'>
            Edit Banner
          </h2>

          <button
            onClick={onClose}
            className='text-gray-500 hover:text-black text-xl'
          >
            ×
          </button>

        </div>

        {/* FORM */}
        <form
          onSubmit={handleSubmit}
          className='space-y-5'
        >

          {/* CAMPAIGN */}
          <div>

            <label className='block text-sm font-medium text-gray-700 mb-1'>
              Campaign Name
            </label>

            <input
              type='text'
              value={campaignName}
              onChange={(e) =>
                setCampaignName(
                  e.target.value
                )
              }
              className='w-full border border-gray-300 rounded-md px-3 py-2'
              placeholder='Enter campaign name'
            />

          </div>

          {/* SCREEN */}
         <div>
  <label className='block text-sm font-medium text-gray-700 mb-1'>
    Screen Name
  </label>

  <select
    value={screenName}
    onChange={(e) =>
      setScreenName(e.target.value)
    }
    className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500'
  >
    <option value=''>
      Select Screen Name
    </option>

    <option value='home_page'>
      Home Page
    </option>

    <option value='category_page'>
      Category Page
    </option>

    <option value='sub_category_page'>
      Sub Category Page
    </option>
  </select>
</div>

{/* HYPER LINK */}
<div>

  <label className='block text-sm font-medium text-gray-700 mb-1'>
    Hyper Link
  </label>

  <input
    type='url'
    value={hyperLink}
    onChange={(e) =>
      setHyperLink(
        e.target.value
      )
    }
    placeholder='Enter redirect URL'
    className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500'
  />

</div>

          {/* FILE */}
          <div>

            <label className='block text-sm font-medium text-gray-700 mb-2'>
              Banner Image (Approx. Resolution: 360 × 140)
            </label>

            <input
              type='file'
              accept='image/*'
              onChange={handleImageChange}
            />

          </div>

          {/* PREVIEW */}
          {preview && (

            <div>

              <p className='text-sm font-medium text-gray-700 mb-2'>
                Preview
              </p>

              <img
                src={preview}
                alt='Preview'
                className='w-full h-52 object-cover rounded-lg border'
              />

            </div>

          )}

          {/* BUTTONS */}
          <div className='flex justify-end gap-3 pt-2'>

            <button
              type='button'
              onClick={onClose}
              className='px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100'
            >
              Cancel
            </button>

            <button
              type='submit'
              disabled={
                updateMutation.isPending
              }
              className='px-5 py-2 bg-primary text-white rounded-md hover:bg-primary/90 disabled:opacity-50'
            >
              {updateMutation.isPending
                ? 'Updating...'
                : 'Update Banner'}
            </button>

          </div>

        </form>
      </div>
    </div>
  );
};

export default EditBannerModal;